<template>
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 z-50 bg-black bg-opacity-60 flex justify-center items-center"
      @click.self="close">
      <div class="bg-white rounded-lg shadow-xl p-6 w-full max-w-md transform transition-all" :class="animationClass">
        <h3 class="text-lg font-bold mb-4 text-gray-800">{{ title }}</h3>

        <div>
          <label :for="`newItemInput-${title}`" class="block text-sm font-medium text-gray-700">{{ label
          }}</label>
          <input :id="`newItemInput-${title}`" type="text" v-model.trim="newItemName" @keyup.enter="handleSave"
            ref="inputField"
            class="mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            :placeholder="`Enter new ${label.toLowerCase()}`" />
          <p v-if="errorMessage" class="text-red-500 text-xs italic mt-1">{{ errorMessage }}</p>
        </div>

        <div class="mt-6 flex justify-end space-x-3">
          <button @click="close"
            class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400">
            Cancel
          </button>
          <button @click="handleSave"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            Save
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AddModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, required: true },
    label: { type: String, default: 'Item Name' },
    existingItems: { type: Array, default: () => [] },
    nameKey: { type: String, default: 'name' }
  },
  data() {
    return { newItemName: '', errorMessage: '', animationClass: '' };
  },
  methods: {
    close() { this.$emit('close'); },
    handleSave() {
      this.errorMessage = '';
      if (!this.newItemName) {
        this.errorMessage = 'Name cannot be empty.';
        return;
      }
      const isDuplicate = this.existingItems.some(
        item => item[this.nameKey]?.toLowerCase() === this.newItemName.toLowerCase()
      );
      if (isDuplicate) {
        this.errorMessage = `${this.label} with this name already exists.`;
        return;
      }
      this.$emit('save', this.newItemName);
    },
    reset() {
      this.newItemName = '';
      this.errorMessage = '';
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.reset();
        this.animationClass = 'scale-100';
        this.$nextTick(() => { this.$refs.inputField.focus(); });
      } else {
        this.animationClass = 'scale-95';
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.transform {
  transition: transform 0.3s ease;
}
</style>